<template>
  <gp-modal
    :header-icon="props.headerIcon"
    :header-image="props.headerImage"
    :header-text="props.headerText"
    :content-text="props.contentText"
    is-opened
    :class="props.aboveInteractivityLock ? gpModalTop : gpModalClass"
    @confirm="handleConfirm()"
    @cancel="handleCancel()"
    @close="handleCancel()"
  >
    <template v-if="$slots.default" #content>
      <div class="px-4" :class="{ 'z-1058': props.aboveInteractivityLock }">
        <slot />
      </div>
    </template>
    <template #footer>
      <div class="flex w-full flex-wrap justify-center gap-4">
        <gp-btn size="sm" btn-type="cancel" class="w-full md:w-40" @click="handleCancel">
          {{ t("general/confirm/cancel_btn_text") }}
        </gp-btn>
        <gp-btn size="sm" class="w-full md:w-40" :disabled="!props.allowConfirm" @click="handleConfirm">
          {{ t("general/confirm/confirm_btn_text") }}
        </gp-btn>
      </div>
    </template>
  </gp-modal>
</template>
<script setup lang="ts" generic="TReturn = unknown">
import type { DialogFuture } from "@/store/dialog";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { GpBtn, GpModal } from "@gportal/uikit";
import { useI18n } from "vue-i18n";
import useNgpDialog from "./dialog";

type DialogFutureParam = TReturn extends unknown ? boolean : [boolean, TReturn];

const { t } = useI18n();
const { gpModalClass, gpModalTop } = useNgpDialog();

const props = withDefaults(
  defineProps<{
    headerText: string;
    headerIcon?: IconDefinition;
    headerImage?: string;
    contentText?: string;
    returnValue?: () => TReturn;
    allowConfirm?: boolean;
    aboveInteractivityLock?: boolean;
    future: DialogFuture<undefined | TReturn>;
  }>(),
  {
    headerIcon: undefined,
    headerImage: undefined,
    contentText: undefined,
    returnValue: undefined,
    allowConfirm: true,
    aboveInteractivityLock: false,
  },
);

const emit = defineEmits<{
  (e: "closeDialog"): void;
}>();

function handleCancel() {
  if (props.returnValue) {
    props.future.resolve([false, undefined] as DialogFutureParam);
  } else {
    props.future.resolve(false as DialogFutureParam);
  }
  closeDialog();
}

function handleConfirm() {
  if (props.returnValue) {
    props.future.resolve([true, props.returnValue()] as DialogFutureParam);
  } else {
    props.future.resolve(true as DialogFutureParam);
  }
  closeDialog();
}

function closeDialog() {
  emit("closeDialog");
}
</script>
